// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__hDVmX","containerInfo":"styles_containerInfo__yFWdg","containerLogo":"styles_containerLogo__7omur","digitally":"styles_digitally__9GQFo"};